import { ConfigConstants } from '../../config/config-constants';
import { NOTIFICATION_STATUS_CODE } from '../../enums/notification-status-code.enum';
import type = ConfigConstants.NotificationTypes;
import STATUS = NOTIFICATION_STATUS_CODE;
import PROCESS = ConfigConstants.PROCESS_INDICATOR;

export type ActivityCodeMapping = [
    type,
    ConfigConstants.PROCESS_INDICATOR,
    NOTIFICATION_STATUS_CODE,
    ActivityCodeResult,
];

export enum ACTIVITY_CODE {
    RMCC = 'RMCC',
    RWRK = 'RWRK',
    REPR = 'REPR',
}

export interface ActivityCodeResult {
    defaultCode?: string[];
    excludeCodes?: string[];
}
// Rule: if [NotificationType, ProcessIndicator, Status] → { defaultCode / exclude }
export const ACTIVITY_CODE_RULE_MATRIX: readonly ActivityCodeMapping[] = [
    // Service type Notification
    [type.Service, PROCESS.INVIVO, STATUS.FCC, { defaultCode: [ACTIVITY_CODE.RMCC] }],
    [type.Service, PROCESS.INVIVO, STATUS.ROSR, { defaultCode: [ACTIVITY_CODE.RWRK] }],
    [type.Service, PROCESS.INVIVO, STATUS.OSR, { defaultCode: [ACTIVITY_CODE.REPR] }],

    [type.Service, PROCESS.INVITRO, STATUS.FCC, { defaultCode: [ACTIVITY_CODE.RMCC] }],
    [type.Service, PROCESS.INVITRO, STATUS.ROSR, { defaultCode: [ACTIVITY_CODE.RWRK] }],
    [type.Service, PROCESS.INVITRO, STATUS.OSR, { excludeCodes: [ACTIVITY_CODE.RMCC, ACTIVITY_CODE.RWRK] }],

    // Training type Notification
    [type.Training, PROCESS.INVIVO, STATUS.FCC, { defaultCode: [ACTIVITY_CODE.RMCC] }],
    [type.Training, PROCESS.INVITRO, STATUS.FCC, { defaultCode: [ACTIVITY_CODE.RMCC] }],

    // Workshop type Notification
    [type.Workshop, PROCESS.INVIVO, STATUS.FCC, { defaultCode: [ACTIVITY_CODE.RMCC] }],
    [type.Workshop, PROCESS.INVITRO, STATUS.FCC, { defaultCode: [ACTIVITY_CODE.RMCC] }],
];
